/* City pages (Sunflower sweep, Oct 2026). Progressive enhancement only; the page works fully without this file.
   1. "Ask Joey" and "Send us a photo" open the site chat in place (window.WNFChatOpen; intent "photo" opens the photo prompt).
   2. Consent-gated GA4: wnf_city_cta_click, wnf_city_chat_open, wnf_city_faq_open (pattern from wnf-financing.js). */
(() => {
  'use strict';
  if (window.wnfswCityInit) return;
  window.wnfswCityInit = true;
  const MEASUREMENT_ID = 'G-0JE425EEKS';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const root = () => document.querySelector('[data-wnfsw-city-page]');
  const track = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return;
    const r = root();
    window.gtag('event', name, {
      send_to: MEASUREMENT_ID,
      page_location: location.origin + location.pathname,
      city: r?.dataset.wnfswCity || '',
      closer_store: r?.dataset.wnfswNear || '',
      ...params
    });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }

  const init = () => {
    if (!root()) return;
    // Capture phase, so this runs before Motion's link handler starts its page transition.
    document.addEventListener('click', (event) => {
      const chat = event.target.closest('[data-wnfsw-chat]');
      if (chat) {
        const intent = chat.dataset.wnfswChat;
        if (typeof window.WNFChatOpen === 'function') {
          event.preventDefault();
          window.WNFChatOpen(intent === 'photo' ? { intent: 'photo' } : undefined);
          track('wnf_city_chat_open', { chat_intent: intent });
          return;
        }
        if (chat.tagName === 'BUTTON') location.href = '/pages/contact-us';
        return;
      }
      const cta = event.target.closest('[data-wnfsw-cta]');
      if (cta) track('wnf_city_cta_click', { cta_placement: cta.dataset.wnfswCta, transport_type: 'beacon' });
    }, true);
    document.querySelectorAll('.wnfsw-faq-list details').forEach((d) => {
      d.addEventListener('toggle', () => {
        if (d.open) track('wnf_city_faq_open', { question: d.querySelector('summary')?.firstChild?.textContent?.trim().slice(0, 90) });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
